import { Dropdown } from 'antd';
import { DownOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import type { TUser } from '@/services/auth/auth.types.ts';
import { roleLabel, useLogout, userFullName } from '@/components/Layouts/account.ts';
import { Avatar } from '@/components/Layouts/Avatar.tsx';

interface IUserMenu {
  user?: TUser;
}

/** Desktop account dropdown: identity, profile link (clients) and logout. */
export const UserMenu = ({ user }: IUserMenu) => {
  const { mutate: logout, isPending } = useLogout();

  return (
    <Dropdown
      trigger={['click']}
      placement='bottomRight'
      overlayClassName='user-menu__dropdown'
      menu={{
        items: [
          {
            key: 'identity',
            type: 'group',
            label: (
              <div className='user-menu__identity'>
                <span className='user-menu__identity-name'>{userFullName(user)}</span>
                <span className='user-menu__identity-email'>{user?.email}</span>
              </div>
            ),
          },
          { type: 'divider' },
          ...(user?.role === 'CLIENT'
            ? [
                {
                  key: 'profile',
                  icon: <UserOutlined />,
                  label: <Link to='/client/profile'>My profile</Link>,
                },
              ]
            : []),
          {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Log out',
            danger: true,
            disabled: isPending,
            onClick: () => logout(),
          },
        ],
      }}
    >
      <button type='button' className='user-menu__trigger' aria-label='Account menu'>
        <Avatar user={user} />
        <span className='user-menu__text'>
          <span className='user-menu__name'>{user?.first_name}</span>
          <span className='user-menu__role'>{roleLabel(user?.role)}</span>
        </span>
        <DownOutlined className='user-menu__caret' />
      </button>
    </Dropdown>
  );
};
